export function PRINCIPAL_REQUEST(state) {
  state;
  state.principals = {
    ...state.principals,
    isLoading: true
  };
}
export function PRINCIPAL_SUCCESS(state, payload) {
  const data = [];
  payload.data.data.principals.rows.map(item => {
    data.push({
      id: item.principalId || "-",
      principalCode: item.principalCode || "-",
      principalName: item.principalName || "-",
      description: item.description || "-",
      logo: item.principalLogo || "-",
      is_active: item.isActive || false
    });
    return item;
  });

  state;
  state.principals = {
    ...state.principals,
    data: data,
    count: payload.data.data.principals.count,
    status: payload.status,
    isLoading: false
  };
}
export function PRINCIPAL_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function GET_PRINCIPAL_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function GET_PRINCIPAL_SUCCESS(state, payload) {
  state;
  state.principal = payload.results.data;
  state.isLoading = false;
}
export function GET_PRINCIPAL_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function CREATE_PRINCIPAL_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function CREATE_PRINCIPAL_SUCCESS(state, payload) {
  state;
  state.principals = [...state.principals, payload.results.data];
  state.isLoading = false;
}
export function CREATE_PRINCIPAL_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function EDIT_PRINCIPAL_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function EDIT_PRINCIPAL_SUCCESS(state, payload) {
  state;
  state.principals = state.principals.map(item => {
    if (item.id === payload.results.data.id) {
      return Object.assign({}, item, payload.results.data);
    }
    return item;
  });
  state.isLoading = false;
}
export function EDIT_PRINCIPAL_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function DELETE_PRINCIPAL_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function DELETE_PRINCIPAL_SUCCESS(state, payload) {
  let index = state.principals.findIndex(item => item.id == payload.id);
  state.principals.splice(index, 1);
  state;
  state.principals;
  state.isLoading = false;
}
export function DELETE_PRINCIPAL_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}
